import { render, staticRenderFns } from "./riskClassDetail.vue?vue&type=template&id=6300b9fe&scoped=true&"
import script from "./riskClassDetail.vue?vue&type=script&lang=js&"
export * from "./riskClassDetail.vue?vue&type=script&lang=js&"
import style0 from "./riskClassDetail.vue?vue&type=style&index=0&id=6300b9fe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6300b9fe",
  null
  
)

export default component.exports